var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid',{ref:"grid",attrs:{"data":_vm.displayData,"loading":_vm.loading,"options":_vm.options},on:{"change-filter":_vm.changeFilter,"radio-change":_vm.onRadioChange}})}
var staticRenderFns = []

export { render, staticRenderFns }